import type { GameModule } from '../types';
import Page from './Page';

// Matka King — the khelpur.com app ported (docs/MATKA_KING_PORT.md). Timed
// number markets: pick a market, a session (open / close, or a slot), type
// numbers + amounts, submit; the house declares the result on the clock and
// the wallet settles by itself. Locked (dev-PIN) until the owner flips it.
const matkaKing: GameModule = {
  id: 'matka_king',
  displayName: 'Matka King',
  tag: 'Jackpot',
  theme: {
    gradient: 'from-amber-600 to-yellow-900',   // matches games.theme_gradient + shared-ui registry
    emoji: '🍯',
    logo: '/games/matka_king/Logo.png',
  },
  // 'any', not 'portrait': a scrolling list/form page must scroll, so it must
  // not sit in the fixed-height, overflow-hidden portrait frame.
  orientation: 'any',
  // …but it still owns the whole screen like every other game (2026-09-19):
  // GameRoute mounts it in the scrolling `.game-fullscreen` frame above the
  // NavBar + BottomNav, and the page carries its own back button + wallet.
  fullscreen: true,
  adminIcon: 'casino',
  adminTheme: {
    headerFrom: 'from-amber-900', headerTo: 'to-yellow-800',
    ring: 'ring-amber-400', accent: 'bg-amber-600', accentHover: 'hover:bg-amber-500',
    dot: 'bg-amber-400', softBg: 'bg-amber-900/30', rangeAccent: 'accent-amber-500',
    badgeClasses: 'bg-amber-600/20 text-amber-300 border-amber-600/30',
  },
  Page,
};

export default matkaKing;
